module.exports = __webpack_public_path__ + "img/mobile-header-banner.0b5ce190.jpg";